import { SettingConst } from '@faire/web-api--source/types';

/**
 * Geo-based setting to determine when we should add credit cards via Adyen
 */
export const USE_ADYEN_FOR_RETAILER_PAYMENTS =
  'USE_ADYEN_FOR_RETAILER_PAYMENTS' as SettingConst<
    'USE_ADYEN_FOR_RETAILER_PAYMENTS',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS' | 'MAKER' | 'VISITOR_WEB'
  >;
